export const PAGE_AUTH = '/auth';
